// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"669":"e59e71aa","781":"0cb598f0"}[chunkId] + ".chunk.css";
};